// extracted by mini-css-extract-plugin
export default {"wrapper":"RefundPolicy_wrapper__HZZ3m","banner":"RefundPolicy_banner__seAsY","email":"RefundPolicy_email__5SLIq"};